import React from 'react'
import PlpMainContent from './PlpMainContent'

const ResultsContainer = ({ containerObject, templateName, contentId, dataZone }) => {
	 return (
        <>
            <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row g-0`} >
                
				<PlpMainContent containerObject={containerObject} />
            </div>
        </>
    )
}

export default ResultsContainer